import { fetchMainApi } from '@/api';

export const getBookmarks = async () => {
  return await fetchMainApi('GET', '/bookmarks');
};

export const addBookmark = async (orderId) => {
  return await fetchMainApi('POST', `/bookmarks/${orderId}`);
};

export const deleteBookmark = async (orderId)=> {
  return await fetchMainApi('DELETE', `/bookmarks/${orderId}`);
};